import { render } from "./BillingSidePanel.vue?vue&type=template&id=8faa10aa&scoped=true"
import script from "./BillingSidePanel.vue?vue&type=script&lang=js"
export * from "./BillingSidePanel.vue?vue&type=script&lang=js"

import "./BillingSidePanel.vue?vue&type=style&index=0&id=8faa10aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8faa10aa"]])

export default __exports__